import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from "./spinner.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

import {SpinnerDirective} from "../../directives/spinner/spinner.directive";


@NgModule({
    declarations: [SpinnerComponent, SpinnerDirective],
    exports: [
        SpinnerDirective,
        SpinnerComponent
    ],
    imports: [
        CommonModule,
        MatProgressSpinnerModule
    ]
})
export class SpinnerModule {
}
